import React, { useEffect, useState } from 'react';
import { Input, Select } from '../../../components/ui/Input';
import Secao from '../../../components/ui/Secao';
import { empresasApi } from '../../../api/admin';
import { useAuth } from '../../../context/AuthContext';

const STATUS = [
  { value: 'ativo', label: 'Ativo' },
  { value: 'ferias', label: 'Férias' },
  { value: 'afastado', label: 'Afastado' },
  { value: 'demitido', label: 'Demitido' }
];

const DIAS = [
  { valor: '1', label: 'Seg' }, { valor: '2', label: 'Ter' }, { valor: '3', label: 'Qua' },
  { valor: '4', label: 'Qui' }, { valor: '5', label: 'Sex' }, { valor: '6', label: 'Sáb' }, { valor: '0', label: 'Dom' }
];

const CARGOS = ['Gestor', 'Vendedor', 'Gerente', 'Almoxarifado', 'Entregador', 'Gerente de Almoxarifado', 'Gerente de Logística'];
const opcoesCargo = [{ value: '', label: 'Selecione...' }, ...CARGOS.map(c => ({ value: c, label: c })), { value: 'outro', label: 'Outro' }];

export default function DadosTrabalhoTab({ form, onChange }) {
  const { tenantId } = useAuth();
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => { empresasApi.listar(tenantId).then(setEmpresas).catch(() => {}); }, [tenantId]);

  const diasSelecionados = (form.dias_semana || '').split(',').filter(Boolean);
  const alternarDia = (dia) => {
    const atual = new Set(diasSelecionados);
    if (atual.has(dia)) atual.delete(dia); else atual.add(dia);
    onChange('dias_semana', Array.from(atual).join(','));
  };

  const opcoesEmpresas = [{ value: '', label: '(sem empresa)' }, ...empresas.map(e => ({ value: e.id, label: e.nome }))];

  const cargoEhPredefinido = form.cargo && CARGOS.includes(form.cargo);
  const selecaoCargo = form.cargo ? (cargoEhPredefinido ? form.cargo : 'outro') : '';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Secao titulo="Vínculo">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
          <Select label="Empresa" options={opcoesEmpresas} value={form.empresa_id || ''} onChange={e => onChange('empresa_id', e.target.value || null)} />
          <div>
            <Select label="Cargo" options={opcoesCargo} value={selecaoCargo} onChange={e => onChange('cargo', e.target.value === 'outro' ? '' : e.target.value)} />
            {selecaoCargo === 'outro' && (
              <Input value={form.cargo || ''} onChange={e => onChange('cargo', e.target.value)} placeholder="Especifique o cargo" style={{ marginTop: 6 }} />
            )}
          </div>
          <Select label="Status" options={STATUS} value={form.status || 'ativo'} onChange={e => onChange('status', e.target.value)} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6, marginTop: 8 }}>
          <Input label="Data de Admissão" type="date" value={form.data_admissao ? form.data_admissao.slice(0, 10) : ''} onChange={e => onChange('data_admissao', e.target.value)} />
          <Input label="Data de Demissão" type="date" value={form.data_demissao ? form.data_demissao.slice(0, 10) : ''} onChange={e => onChange('data_demissao', e.target.value)} />
          <Input label="Salário R$" type="number" step="0.01" value={form.salario || ''} onChange={e => onChange('salario', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Horário de Trabalho">
        <Input label="Turno" value={form.turno || ''} onChange={e => onChange('turno', e.target.value)} style={{ maxWidth: 260, marginBottom: 8 }} />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>
          <Input label="Entrada" type="time" value={form.hora_entrada || ''} onChange={e => onChange('hora_entrada', e.target.value)} />
          <Input label="Saída Almoço" type="time" value={form.hora_saida_almoco || ''} onChange={e => onChange('hora_saida_almoco', e.target.value)} />
          <Input label="Volta Almoço" type="time" value={form.hora_volta_almoco || ''} onChange={e => onChange('hora_volta_almoco', e.target.value)} />
          <Input label="Saída" type="time" value={form.hora_saida || ''} onChange={e => onChange('hora_saida', e.target.value)} />
        </div>
        <div style={{ marginTop: 10 }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: '#64748B', marginBottom: 6 }}>Dias da Semana</div>
          <div style={{ display: 'flex', gap: 6 }}>
            {DIAS.map(d => (
              <button key={d.valor} type="button" onClick={() => alternarDia(d.valor)}
                style={{
                  padding: '6px 12px', borderRadius: 7, border: '1.5px solid #E4EAF0', cursor: 'pointer', fontSize: 12, fontWeight: 600,
                  background: diasSelecionados.includes(d.valor) ? '#1d6bf0' : '#fff',
                  color: diasSelecionados.includes(d.valor) ? '#fff' : '#64748B'
                }}>
                {d.label}
              </button>
            ))}
          </div>
        </div>
      </Secao>
    </div>
  );
}
